import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { verifyPaymentStatus } from '../../api/services/paymentService';

const PaymentResponsePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get('order_id');
  const studentId = searchParams.get('student_id');

  const contactEmail = 'info@q2d.in';

  useEffect(() => {
    if (!orderId || !studentId) {
      navigate('/', { replace: true });
      return;
    }

    const fetchPaymentStatus = async () => {
      try {
        const status = await verifyPaymentStatus(orderId, studentId);

        console.log('Payment status:', status);

        const orderDetails = status.orderDetails;

        if (status?.status === 'success' && status?.paymentStatus === 'PAID') {
          navigate('/thank-you', {
            replace: true,
            state: {
              application: orderDetails,
              orderId: orderDetails.orderId,
              amount: orderDetails.amount,
              paidAt: orderDetails.paidAt,
              email: orderDetails.email,
            },
          });
          return;
        }

        if (status?.paymentStatus === 'FAILED') {
          navigate('/payment-failed', { replace: true });
          return;
        }

        navigate('/payment-pending', { replace: true });
      } catch (err) {
        console.error('Payment verification error:', err);
        navigate('/payment-failed', { replace: true });
      }
    };

    fetchPaymentStatus();
  }, [orderId, studentId, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        padding: '2rem',
      }}
    >
      <div>
        <div
          style={{
            fontSize: '3rem',
            color: '#0d6efd',
            marginBottom: '1rem',
          }}
        >
          🔍
        </div>
        <h4>Verifying Payment...</h4>
        <p style={{ color: '#6c757d' }}>
          Please wait while we confirm your payment status.
        </p>
      </div>
    </div>
  );
};

export default PaymentResponsePage;